<div *ngIf="educations.length > 0">
	<div
		*ngFor="let education of sortEducations(educations)"
		class="
			zk-flex zk-items-center zk-relative zk-mb-2 zk-rounded-md
			education-item
		"
	>
		<p (click)="editEducation(education)">
			<span class="education-title">{{ education.title }}</span>
			<span> | {{ translateEducationType(education.educationType) }}</span>
			<span *ngIf="!education.institution"> | </span>
			<span *ngIf="education.institution"
				><br />{{ education.institution }} |
			</span>
			<span>{{ education.educationYear }}</span>
		</p>

		<div class="zk-w-6 zk-text-center">
			<zk-icon
				class="zk-ml-1 zk--mr-1 zk-cursor-pointer close-icon"
				name="close"
				[height]="'1.0625rem'"
				[width]="'1.0625rem'"
				(click)="onRequestRemoveEducation(education)"
			></zk-icon>
		</div>
	</div>
</div>

<button
	zk-button
	zkButtonColor="secondary"
	class="zk-mt-4 zk-mb-6"
	zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
	(click)="addEducation()"
>
	{{
		'MY_ACCOUNT.PROFESSIONAL.FORM.EDUCATION.ADD_EDUCATION_BUTTON' | translate
	}}
</button>

<zk-dialog
	class="education-dialog"
	[(isOpen)]="isDialogEducationOpen"
	[clickOverlayCloses]="false"
>
	<ng-container zk-dialog-header>
		<p class="dialog-title zk-text-white-base zk-text-base zk-p-0">
			<ng-container *ngIf="educationCurrentItem; else AddTitle">
				{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.EDIT' | translate }}
			</ng-container>
			<ng-template #AddTitle>
				{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ADD' | translate }}
			</ng-template>
		</p>
	</ng-container>
	<ng-container zk-dialog-body>
		<form
			#formElement
			*ngIf="isEducationFormShown"
			[formGroup]="formGroupEducation"
			(ngSubmit)="saveEducation()"
		>
			<zk-input
				class="sm:zk-mt-0 zk-mb-4"
				[zkStatus]="
					isFieldInvalid(formGroupEducation, 'title') ? 'error' : 'default'
				"
			>
				<input
					id="education-title"
					zkInputRef
					formControlName="title"
					placeholder="{{
						'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.TITLE.LABEL' | translate
					}}"
				/>
				<span zkInputLabel>{{
					'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.TITLE.LABEL' | translate
				}}</span>
				<span zkInputMessage>
					<ng-container *ngIf="!isFieldInvalid(formGroupEducation, 'title')">
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.TITLE.DESCRIPTION'
								| translate
						}}
					</ng-container>
					<ng-container *ngIf="isFieldInvalid(formGroupEducation, 'title')">
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ERRORS.TITLE' | translate
						}}
					</ng-container>
				</span>
			</zk-input>

			<zk-input
				class="zk-mb-3 sm:zk-mt-1"
				[zkStatus]="
					isFieldInvalid(formGroupEducation, 'institution')
						? 'error'
						: 'default'
				"
			>
				<input
					id="education-institution"
					zkInputRef
					formControlName="institution"
					placeholder="{{
						'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.INSTITUTION.LABEL'
							| translate
					}}"
				/>
				<span zkInputLabel>{{
					'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.INSTITUTION.LABEL'
						| translate
				}}</span>
				<span zkInputMessage>
					<ng-container
						*ngIf="!isFieldInvalid(formGroupEducation, 'institution')"
					>
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.INSTITUTION.DESCRIPTION'
								| translate
						}}
					</ng-container>
					<ng-container
						*ngIf="isFieldInvalid(formGroupEducation, 'institution')"
					>
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ERRORS.INSTITUTION'
								| translate
						}}
					</ng-container>
				</span>
			</zk-input>

			<div
				class="zk-h-14"
				[class.dropdown-container-error]="
					isFieldInvalid(formGroupEducation, 'educationType')
				"
			>
				<div
					[class.zk-absolute]="
						formElement.parentElement?.scrollHeight ===
						formElement.parentElement?.clientHeight
					"
					class="education-dropdown"
				>
					<zk-dropdown
						class="sm:zk-mt-1"
						id="education-type"
						[label]="
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.TYPE.LABEL' | translate
						"
						[value]="formGroupEducation.get('educationType')?.value || ''"
						formControlName="educationType"
						[options]="educationTypeOptions"
						[zkStatus]="
							isFieldInvalid(formGroupEducation, 'educationType')
								? 'error'
								: 'default'
						"
					></zk-dropdown>
					<div
						*ngIf="isFieldInvalid(formGroupEducation, 'educationType')"
						class="zk-text-left zk-text-error zk-text-xs zk-mt-1 zk-px-4"
					>
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ERRORS.TYPE' | translate
						}}
					</div>
				</div>
			</div>
			<div
				class="zk-h-14 zk-mt-4 zk-mb-1"
				[class.dropdown-container-error]="
					isFieldInvalid(formGroupEducation, 'educationYear')
				"
			>
				<div
					[class.zk-absolute]="
						formElement.parentElement?.scrollHeight ===
						formElement.parentElement?.clientHeight
					"
					class="education-dropdown"
				>
					<zk-dropdown
						class="sm:zk-mt-1"
						id="education-finished-in"
						[label]="
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.FINISHED__IN' | translate
						"
						formControlName="educationYear"
						[zkStatus]="
							isFieldInvalid(formGroupEducation, 'educationYear')
								? 'error'
								: 'default'
						"
						[options]="educationFinishedInOptions"
					></zk-dropdown>
					<div
						*ngIf="isFieldInvalid(formGroupEducation, 'educationYear')"
						class="zk-text-left zk-text-error zk-text-xs zk-mt-1 zk-px-4"
					>
						{{
							'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ERRORS.FINISHED_IN'
								| translate
						}}
					</div>
				</div>
			</div>
		</form>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="md:zk-px-4 zk-flex zk-items-center zk-w-full md:zk--mb-4">
			<button
				zk-button
				zkButtonColor="secondary"
				id="education-button-cancel"
				class="zk-mr-4"
				[disabled]="isSaving"
				zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
				(click)="closeModalEducation()"
			>
				{{
					'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ACTIONS.CANCEL' | translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				id="education-button-save"
				[zkButtonLoading]="isSaving"
				zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
				(click)="saveEducation()"
			>
				{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ACTIONS.SAVE' | translate }}
			</button>
		</div>
	</ng-container>
</zk-dialog>

<zk-dialog
	class="education-remove-dialog"
	[(isOpen)]="isDialogEducationRemoveOpen"
	[clickOverlayCloses]="false"
>
	<ng-container zk-dialog-header>
		<p class="dialog-title zk-text-white-base zk-text-base zk-p-0">
			{{ 'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.DELETE' | translate }}
		</p>
	</ng-container>
	<ng-container zk-dialog-body>
		<div
			class="
				remove-dialog-body
				sm:zk-px-8
				zk-py-1
				md:zk-px-0
				zk-leading-6
				md:zk-text-base md:zk-pt-0 md:zk-pb-6
			"
		>
			{{
				'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.DELETE_DESCRIPTION' | translate
			}}
		</div>
	</ng-container>
	<ng-container zk-dialog-footer>
		<div class="md:zk-px-4 zk-flex zk-items-center md:zk--mb-4">
			<button
				zk-button
				zkButtonColor="secondary"
				id="education-remove-button-confirm"
				class="zk-mr-4 remove-button"
				[zkButtonLoading]="isSaving"
				zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
				(click)="removeEducation()"
			>
				{{
					'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ACTIONS.CONFIRM' | translate
				}}
			</button>
			<button
				zk-button
				zkButtonColor="primary"
				id="education-remove-button-abort"
				class="remove-button"
				[disabled]="isSaving"
				zkButtonSize="{{ isMobile ? 'small' : 'medium' }}"
				(click)="closeModalEducation()"
			>
				{{
					'MY_ACCOUNT.PROFESSIONAL.MODAL.EDUCATION.ACTIONS.ABORT' | translate
				}}
			</button>
		</div>
	</ng-container>
</zk-dialog>
